export const LOADING_SUBSCRIPTIONS = 'LOADING_SUBSCRIPTIONS';
export const RELOADING_SUBSCRIPTIONS = 'RELOADING_SUBSCRIPTIONS';
export const SET_SUBSCRIPTIONS_STATUS = 'SET_SUBSCRIPTIONS_STATUS';
export const SET_SUBSCRIPTIONS_USERS = 'SET_SUBSCRIPTIONS_USERS';
export const SUBSCRIPTIONS_USER_ADDED = 'SUBSCRIPTIONS_USER_ADDED';
export const SUBSCRIPTIONS_USER_REMOVED = 'SUBSCRIPTIONS_USER_REMOVED';


export const MANAGE_PENDING = 'SUBSCRIPTIONS_MANAGE_PENDING';
export const MANAGE_DONE = 'SUBSCRIPTIONS_MANAGE_DONE';



// WEBPACK FOOTER //
// ./app/actions/subscriptions.js